import React from "react";
// reactstrap components
import {
  Button,
  Collapse,









  Container, Nav, Navbar,
  // DropdownToggle,
  // DropdownMenu,
  // DropdownItem,
  // UncontrolledDropdown,
  NavbarBrand,

  NavItem,
  NavLink,


  UncontrolledTooltip
} from "reactstrap";

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} expand="lg" color="info">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              href="https://farmkb.net"
              target="_blank"
              id="navbar-brand"
            >
              farmkb.net
            </NavbarBrand>
            <UncontrolledTooltip target="#navbar-brand">
              지리산 시례골 경봉 농원
            </UncontrolledTooltip>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              {
                // <NavItem>
                //   <NavLink
                //     href="#pablo"
                //     onClick={e => {
                //       e.preventDefault();
                //       document
                //         .getElementById("download-section")
                //         .scrollIntoView();
                //     }}
                //   >
                //     <i className="now-ui-icons arrows-1_cloud-download-93"></i>
                //     <p>Download</p>
                //   </NavLink>
                // </NavItem>
              }
              <NavItem>
                <Button
                  className="nav-link btn-neutral"
                  color="info"
                  href="https://smartstore.naver.com/sirye"
                  target="_blank"
                  id="go-to-smartstore"
                >
                  <i className="now-ui-icons shopping_basket"></i>
                  <p>스마트 스토어 바로가기</p>
                </Button>
                <UncontrolledTooltip target="#go-to-smartstore">
                  네이버 페이로 구매 가능합니다
                </UncontrolledTooltip>
              </NavItem>

              <NavItem>
                <NavLink
                  href="https://www.instagram.com/persimmondry"
                  target="_blank"
                  id="instagram-tooltip"
                >
                  <i className="fab fa-instagram"></i>
                  <p className="d-lg-none d-xl-none">Instagram</p>
                </NavLink>
                <UncontrolledTooltip target="#instagram-tooltip">
                  인스타 그램 구경하기
                </UncontrolledTooltip>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default IndexNavbar;
